import { Box, type BoxProps } from "@mui/material";
import { useEasierTheme } from "datalign-themes";
import React, { useState } from "react";
import Toolbox from "datalign-module-template/components/Toolbox";
import { MaterialIcon } from "ui-widgets";

const AlternateSearchInput = (props: {
  value?: string;
  onChange: (value: string) => void;
  boxProps?: BoxProps;
}) => {
  const [uid] = React.useState(Toolbox.UUIDv4());
  const easierTheme = useEasierTheme();

  const [focused, setFocused] = useState(false);

  return (
    <Box
      sx={{
        fontSize: "0.6rem",
        minWidth: "8rem",
        backgroundColor: easierTheme?.Colour.SurfaceContainerHigh(),
        outline: `1px solid ${focused ? easierTheme?.Colour.Outline() : "transparent"}`,
        transition: "all 300ms cubic-bezier(0.2, 0, 0, 1)",
        height: "40px",
        minHeight: "40px",
        borderRadius: "28px",
        border: "none",
        padding: "0px 16px",
        cursor: "text",
        mt: 1,
        mx: 1,
        maxWidth: "400px",
      }}
      display="flex"
      alignItems="center"
      onClick={() => document.getElementById(uid)?.focus()}
      {...props.boxProps}
    >
      <MaterialIcon
        icon="search"
        style={{
          color: easierTheme?.Colour.OnSurface(),
        }}
      />

      <input
        id={uid}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        placeholder="Filter by name"
        style={{
          lineHeight: "1.5rem",
          fontSize: "1rem",
          letterSpacing: "0.03125",
          fontWeight: 400,
          marginLeft: "16px",
          border: "none",
          backgroundColor: "transparent",
          outline: "none",
          flex: 1,
          color: easierTheme?.Colour.OnSurface(),
        }}
        value={props.value ?? ""}
        onChange={(e) => props.onChange(e.target.value)}
      />
    </Box>
  );
};

export default AlternateSearchInput;
